import { Injectable } from '@angular/core';
import { AngularFirestore, AngularFirestoreCollection } from "@angular/fire/firestore";
import { map, finalize } from "rxjs/operators";
import { cursoI } from "../shared/models/curso.interface";
import { Observable } from "rxjs";
import { fileI } from '../shared/models/file.interface';
import { AngularFireStorage } from '@angular/fire/storage';




@Injectable({
  providedIn: 'root'
})
export class UsuariosService {

  private coleccionUsuarios:AngularFirestoreCollection;

  constructor(private afs:AngularFirestore, private storage:AngularFireStorage) 
  {
    this.coleccionUsuarios = afs.collection('users');
  }

  public getAllUsers():Observable<any>
  {
     return this.coleccionUsuarios.snapshotChanges().pipe(
       map(actions=>
        
          actions.map(a=>
            {
              const data = a.payload.doc.data();
              //console.log(data);
              return data; 
            })
            
        )
     )
  }
}
